"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { HeroSlide } from "../types/synergyTypes";
import styles from "./HeroSection.module.css";
import stylesGeneral from "./General.module.css";
import "./swiper-custom.css";

interface HeroSectionProps {
  slides: HeroSlide[];
}

const bulletColor = "#7C3AED";

const HeroSection: React.FC<HeroSectionProps> = ({ slides }) => (
  <section className="relative bg-gradient-to-b h-[750px] from-black to-neutral-900 text-white flex items-center justify-center overflow-hidden">
    <Swiper
      modules={[Pagination, Autoplay]}
      pagination={{
        clickable: true,
        renderBullet: (index: number, className: string) =>
          `<span class='${className}' style='background:${bulletColor}'></span>`,
      }}
      loop
      autoplay={{
        delay: 15000,
        disableOnInteraction: false,
      }}
      className={`w-full h-full ${styles.swiperPagination}`}
    >
      {slides.map((slide, idx) => (
        <SwiperSlide key={idx}>
          <div className="relative w-full h-full">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            />

            {/* Content */}
            <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 py-20 gap-10 h-full">
              <div className="max-w-xl flex-1 flex flex-col justify-center md:justify-start">
                <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl text-neutral-300 mb-8">
                  {slide.description}
                </p>
                <div className="flex gap-4 mb-6">
                  {/* <a
                    href={slide.ctaPrimary.url}
                    className={`px-[24px] py-[6px] bg-primary ${stylesGeneral.bgGradientWhite} text-black hover:text-white   rounded-full font-medium hover:bg-primary/90 transition-colors`}
                  >
                    {slide.ctaPrimary.text}
                  </a> */}
                  <a
                    href={slide.ctaSecondary.url}
                    className="px-[24px] py-[6px] flex flex-row items-center gap-2 border border-white bg-transparent text-white rounded-full font-medium hover:bg-white hover:text-black transition-colors"
                  >
                    <svg
                      width="10"
                      height="11"
                      viewBox="0 0 10 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 3.76795C10.3333 4.53775 10.3333 6.46225 9 7.23205L3.75 10.2631C2.41667 11.0329 0.75 10.0707 0.75 8.53109L0.750001 2.46891C0.750001 0.929308 2.41667 -0.0329403 3.75 0.73686L9 3.76795Z"
                        fill="#B0B0B0"
                      />
                    </svg>

                    {slide.ctaSecondary.text}
                  </a>
                </div>
                <div className="flex flex-col gap-2">
                  {slide?.links?.map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-primary transition"
                    >
                      <span className="w-2 h-2 rounded-full inline-block bg-primary/80" />
                      {link.text}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </section>
);

export default HeroSection;
